// src/pages/NotFound.js
import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            minHeight="80vh"
            textAlign="center"
        >
            <Typography variant="h1" color="primary" fontWeight="bold">
                404
            </Typography>
            <Typography variant="h5" sx={{ mb: 3 }}>
                Page not found.
            </Typography>
            <Button variant="contained" onClick={() => navigate('/')}>
                Back to Homepage
            </Button>
        </Box>
    );
};

export default NotFound;
